// src/pages/pengamatan/buah-alami/detail-tabs/RencanaPanenBuahAlamiTableHeader.jsx
import React from 'react';
import {
    TableHead,
    TableRow,
    TableCell,
} from '@mui/material';

const RencanaPanenBuahAlamiTableHeader = () => {
    return (
        <TableHead>
            <TableRow>
                {/* Plot */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    Plot
                </TableCell>
                
                {/* Luas */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    Luas
                </TableCell>
                
                {/* PJP */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }} rowSpan={3}>
                    PJP
                </TableCell>
                
                {/* Fase Bunga - Header Utama */}
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0', textAlign: 'center'}} colSpan={14}>
                    Fase Bunga
                </TableCell>
            </TableRow>
            
            {/* Sub-header untuk Fase Bunga */}
            <TableRow>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Open Heart</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Red Bud 1.25</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Red Bud 2.54</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Early Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Mid Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Late Cones</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Early Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Mid Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Late Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Dry Petals</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Filling Stage 1</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>Filling Stage 2</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>SC0</TableCell>
                <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>SC0&gt;</TableCell>

            </TableRow>
            
            {/* Sub-sub-header untuk Fase Bunga */}
            <TableRow>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(36-37)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(39-40)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(42-44)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(46-48)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(51-53)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(54-56)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(57-58)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(60-62)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(64-65)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(67-72)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(73-105)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(106-125)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(126-130)</TableCell>
                <TableCell sx={{ borderRight: '1px solid #e0e0e0', padding:'4px !important', textAlign:'center !important', fontSize:'11px' }}>(&gt;130)</TableCell>
            </TableRow>
        </TableHead>
    );
};

export default RencanaPanenBuahAlamiTableHeader;